import { useClickOutside } from '@/global/hooks'
import { RefObject } from 'react'
import { useMapScrollOutside } from '../useMapScrollOutside/useMapScrollOutside'

interface UseInteractionOutsideProps {
  ref: RefObject<HTMLElement | null> | RefObject<HTMLElement | null>[]
  callback: () => void
  breakpoint?: number
  ignoredElement?: RefObject<HTMLElement | null>
}

const useInteractionOutside = ({
  ref,
  callback,
  breakpoint,
  ignoredElement
}: UseInteractionOutsideProps) => {
  useClickOutside({
    ref,
    callback,
    breakpoint,
    ignoredElement
  })

  useMapScrollOutside({
    ref,
    callback,
    breakpoint
  })
}

export { useInteractionOutside }
export type { UseInteractionOutsideProps }
